import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Sparkles, ShieldCheck, Lock, CreditCard } from 'lucide-react';
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/uxFUMbp7rpyj5PEWokPKpa/heylloyd-image-1778600585408.png';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" style={{
    background: 'linear-gradient(160deg, #FFFFFF 0%, #FFF5F5 100%)'
  }} data-id="element-174">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-175">
        <div className="text-center mb-8" data-id="element-176">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-softGreen text-brand-accent border border-brand-verifiedGreen font-bold mb-6 uppercase tracking-wider text-[12px]" data-id="element-177">
            ⭐ +300 mujeres ya lo tienen
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-6 leading-tight" data-id="element-178">
            Tu cuerpo no está roto.
          </h1>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight" data-id="element-179">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-accent to-brand-terracotta" data-id="element-180">
              Solo nadie te dio el sistema correcto.
            </span>
          </h2>

          <div className="relative w-full max-w-sm mx-auto mb-8" data-id="element-181">
            <img src={LCP_IMAGE} alt="Megapack: Reset Digestivo y Emocional — Guía Holística para el Equilibrio Femenino, Cuerpo y Alma" className="w-full rounded-3xl shadow-lg" fetchPriority="high" loading="eager" width={512} height={768} decoding="async" sizes="(max-width: 768px) 80vw, 384px" style={{
            aspectRatio: '2/3'
          }} data-id="element-182" />
          </div>

          <p className="text-xl md:text-2xl text-brand-muted mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-183">
            Reducí la hinchazón, recuperá tu energía y calmá la ansiedad en 72
            horas.
          </p>

          <p className="text-lg text-brand-muted mb-10 max-w-2xl mx-auto" data-id="element-184">
            Sistema completo de reset digestivo y emocional. Sin dietas
            restrictivas. Sin gimnasio. Desde tu casa.
          </p>
        </div>

        <FadeIn delay={0.2} className="flex flex-col items-center" data-id="element-185">
          <Button href="https://librofy-store.myshopify.com/checkouts/cn/hWNC5bkkb5zQBlHOdZSJJSkL/es-ar?_r=AQABVzLO_KpqrOt2lcmiXV4nZHYRt7MyxvAb-3nsE9SQP7Q&preview_theme_id=160306823389" size="xl" variant="terracotta" className="mb-6 group" data-id="element-186">
            🌿 Quiero mi Megapack edición completa AHORA
          </Button>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-brand-muted mb-12" data-id="element-187">
            <div className="flex items-center gap-1.5" data-id="element-188">
              <ShieldCheck className="w-4 h-4 text-brand-accent" data-id="element-189" /> Garantía 7
              días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-190">
              <Lock className="w-4 h-4 text-brand-accent" data-id="element-191" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-192">
              <CreditCard className="w-4 h-4 text-brand-accent" data-id="element-193" /> Mercado Pago
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-194">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-brand-card border border-brand-border p-6 rounded-2xl shadow-sm" data-id="element-195">
            <div className="flex flex-col items-center text-center gap-2" data-id="element-196">
              <Sparkles className="w-6 h-6 text-brand-accent" data-id="element-197" />
              <span className="font-medium text-sm" data-id="element-198">3 Tomos Completos</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-199">
              <span className="text-2xl" data-id="element-200">⚡</span>
              <span className="font-medium text-sm" data-id="element-201">Acceso en 5 min</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-202">
              <span className="text-2xl" data-id="element-203">🇦🇷</span>
              <span className="font-medium text-sm" data-id="element-204">Para Argentina</span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-205">
              <span className="text-2xl" data-id="element-206">📱</span>
              <span className="font-medium text-sm" data-id="element-207">100% Digital</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}